<div class="flex align-items-center justify-content-center">
    <app-loading
    [visible]="loadingProvider.isVisible()"
    ></app-loading>
</div>
